import Keycloak from 'keycloak-js';
import { keyCloakConfig } from '@settings';

const kc = Keycloak(keyCloakConfig);

kc.onAuthSuccess = () => {
  console.log('Authentication successful');
};

// Initialize Keycloak with checkLogin set to false to prevent automatic redirects
let isInitialized = false;
export async function loadKc() {
  if (!isInitialized) {
    const initOptions = {
      promiseType: 'native',
      onLoad: 'check-sso',
      checkLoginIframe: true,
    };

    await kc.init(initOptions);
    isInitialized = true;
  }
}

export async function signOut() {
  await loadKc();
  return kc.logout();
}

export async function getUserProfile() {
  await loadKc();
  const userProfile = await kc.loadUserInfo();
  return userProfile;
}

export default kc;
